<template>
  <div class="menu flex flex-wrap -mx-2">

    <vue-headful
      :title="title"
      :description="description"
      image="https://foodi.de/static/og_image.jpg"
      lang="de"
      ogLocale="de_DE"
      :url="company.url"
    />

    <div class="w-full lg:w-2/3 px-2">
      <h1 id="cat-selector" class="mb-6">Speisekarte <template v-if="!isPosApp">{{ host.item_name }}</template></h1>

      <div v-if="errors.length" class="bg-red-lightest border border-red-light text-red-dark px-4 my-2 py-3 rounded relative" role="alert">
        <strong class="font-bold">Oh no!</strong>
        <span class="block sm:inline" v-for="error in errors" :key="error">{{ error }} </span>
      </div>

      <activehostcomponent :host="host" :active="active" :away="away"></activehostcomponent>

      <productrules></productrules>

      <div v-if="open && open.isOpen == 0 && allowAddProducts && !away" class="bg-orange-lightest border-l-4 border-orange text-orange-darker p-4 mb-4" role="alert">
        <p class="font-bold">Momentan geschlossen</p>
        <p>Der gewählte Anbieter öffnet in {{ Math.round(open.openingIn / 60) }} Minuten - du kannst schon jetzt vorbestellen!</p>
      </div>

      <div v-if="!open && allowAddProducts && !away" class="bg-orange-lightest border-l-4 border-orange text-orange-darker p-4 mb-4" role="alert">
        <p class="font-bold">Heute geschlossen</p>
        <p>Der gewählte Anbieter öffnet heute nicht mehr aber du kannst vorbestellen!</p>
      </div>

      <div v-if="host.item_type !== 'strandbutler' && allowAddProducts && !isPosApp && away == false && !isOfficeClient && !host.isInternal" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm" v-bind:class="{ 'border-4': isOfficeMaster }" role="alert">
        <p v-if="!isOfficeMaster" class="font-bold">Gruppenbestellung geplant?</p>
        <p v-if="isOfficeMaster" class="font-bold">Gruppenbestellung aktiv!</p>
        <p>
          Nutze unseren Link für einfache Gruppenbestellungen. Wer über deinen Link bestellt, legt die Waren direkt in deinen Warenkorb und du kannst entspannt für das ganze Team bestellen. Dein Warenkorb aktualisiert sich dabei automatisch sobald einer deiner Kollegen seine Bestellung hinzugefügt hat.<br />
          <a v-if="!isOfficeMaster" class="font-bold text-black" href="javascript:void(0);" v-on:click="createOfficeSession()">
            <span>Direkt starten und Kollegen einladen!</span>
          </a>

          <a v-if="isOfficeMaster" class="block mt-4 font-bold text-black" href="javascript:void(0);" v-on:click="abortOfficeOrderMaster">
            <span>Gruppenbestellung abbrechen</span>
          </a>
        </p>
      </div>

      <div v-if="isOfficeMaster" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm" role="alert">
        <p class="font-bold">
          ☝️ Link
          <template v-if="isOfficeOrderClipboardSuccess">kopiert</template>
          <template v-if="!isOfficeOrderClipboardSuccess">kopieren</template>
        </p>

        <p>Einfach den folgenden Link kopieren und zum Mitbestellen deinen Kollegen senden:</p>
        <div class="flex items-center flex-wrap md:flex-no-wrap">
          <div @click="copyUrl(officeOrderLink)" class="inline-block max-w-full overflow-auto border p-2 mt-2 bg-white font-mono cursor-pointer">{{ officeOrderLink }}</div>
          <div class="pt-1">
            <button class="sm:ml-2 shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold my-1 py-2 px-4 rounded" @click="inviteClients()">
              <template v-if="hasNavigatorShare">Link teilen</template>
              <template v-if="!hasNavigatorShare">Link per Mail senden</template>
            </button>
          </div>
        </div>
      </div>

      <div v-if="isOfficeOrderShareSuccess" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm" role="alert">
        <p class="font-bold">☝️ Einladung versendet</p>
        <p>Du hast den Link zum Mitbestellen an deine Kollegen geschickt 👍</p>
      </div>

      <div v-if="host.item_coupon_kickback > 0" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm" role="alert">
        <p class="font-bold">🎉 Treuebonus-Programm</p>
        <p>{{ host.item_name }} nimmt an unserm Treuebonus-Programm teil. Das bedeutet für dich, dass du mit deiner Bestellbestätigung einen Rabattgutschein i.H.v. {{ host.item_coupon_kickback }}% des Warenwertes für deine nächste Bestellung bei diesem Restaurant erhältst 🎉</p>
      </div>

      <div v-for="special in specials" :key="special.item_title" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm" role="alert">
        <p class="font-bold">🔥 Tagesaktion noch bis {{ special.item_stop }} Uhr: {{ special.item_title }}</p>
        <p>{{ special.item_content }}</p>
      </div>

      <div v-if="isOfficeClient" class="bg-grey-lightest border-4 border-green p-4 mb-8 text-sm" role="alert">
        <p class="font-bold">Gruppenbestellung: Mitbesteller-Modus</p>
        <p>
          Du nutzt die Mitbesteller-Funktion einer Gruppenbestellung. Lege deine gewünschten Artikel in den Warenkorb und sende diesen ab, wenn du fertig bist. Deine Artikel landen dann im Warenkorb desjenigen, der dir den Link zugeschickt hat.<br />
          <a class="font-bold text-black" href="javascript:void(0);" v-on:click="abortOfficeOrderClient()">Gruppenbestellung abbrechen?</a>
        </p>
      </div>

      <div v-if="away == false && host.item_menu_content && host.item_menu_content.length > 7" class="item_menu_content" v-html="host.item_menu_content"></div>

      <img v-if="host.item_teamphoto && host.item_teamphoto != ''" :src="host.item_teamphoto" :alt="'Team ' + host.item_name" :title="'Team ' + host.item_name" class="w-full mb-4 rounded" style="object-fit: contain; max-height: 500px;" />

      <template v-if="allowAddProducts && away == false">
        <h2 class="m-0 border-b-0 text-xl">Kategorien</h2>
        <ul class="flex flex-wrap list-reset -mx-2">
          <li class="w-full sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6 p-2" v-for="(category, categoryId) in orderedCategories" :key="categoryId">
            <button class="zoomhover-base flex items-start justify-start text-left jumpmark leading-normal w-full h-full overflow-wrap-anywhere" @click="scrollToCategory(categoryId, true)" v-html="category[0].categoryName" />
          </li>
        </ul>

        <div class="max-w-full overflow-auto lg:pr-1" v-for="(category, categoryId) in orderedCategories" :key="category[0].categoryId">
          <table class="products my-8">
            <thead>
              <tr v-if="category[0].categoryImage !== null">
                <th colspan="100%" class="h-64 pt-8 pb-4" :aria-label="'Kategorie ' + category[0].categoryName + ' Hintergrundbild'">
                  <div class="w-full h-full rounded bg-cover bg-center" :style="'background-image:url(' + category[0].categoryImage + ')'"></div>
                </th>
              </tr>
              <tr>
                <th class="productlabel bottomborder-green p-2">
                  <h2 :id="'cat-' + categoryId" class="border-b-0 m-0" v-html="category[0].categoryName"></h2>
                </th>
                <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="category[0].priceTiny">
                  <template v-if="category[0].titleTiny">{{ category[0].titleTiny }}</template>
                  <template v-else>Mini</template>
                </th>
                <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="category[0].priceSmall">
                  <template v-if="category[0].titleSmall">{{ category[0].titleSmall }}</template>
                  <template v-else>Klein</template>
                </th>
                <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="category[0].priceMedium">
                  <template v-if="category[0].titleMedium">{{ category[0].titleMedium }}</template>
                  <template v-else>Mittel</template>
                </th>
                <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="category[0].priceLarge">
                  <template v-if="category[0].titleLarge">{{ category[0].titleLarge }}</template>
                  <template v-else>Groß</template>
                </th>
                <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="category[0].priceFamily">
                  <template v-if="category[0].titleFamily">{{ category[0].titleFamily }}</template>
                  <template v-else>Familie</template>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in category" :key="product.id" class="product">
                <td class="productlabel p-2" v-on:click="showproductsizes" :data-id="product.id">
                  <div v-if="product.image" class="productImageContainer">
                    <img :src="product.image" :alt="product.title" class="productImage" />
                  </div>
                  <div v-if="showProductNumbers && product.artNo" class="productNumberContainer">
                    {{ product.artNo }}
                  </div>
                  <div v-if="product.isNew" class="productNumberContainer">
                    NEU
                  </div>
                  <span v-if="product.isSpecial" class="float-left pr-2">🔥</span>
                  <div class="title">
                    {{ product.title }}
                    <span v-if="product.isVeggie" title="vegetarisch">🌱</span>
                  </div>
                  <div class="content">{{ product.content }}</div>
                  <div class="ingredients">
                    <span v-for="productIngredient in product.productIngredients" :key="productIngredient.title">
                      <span v-if="productIngredient.count === 2" class="px-1">doppelt</span>
                      <span v-if="productIngredient.count === 3" class="px-1">dreifach</span>
                      {{ productIngredient.title }}
                    </span>
                  </div>
                  <div v-if="product.productAttributes != ''" class="ingredients pl-4 text-grey-darkest">
                    {{ product.productAttributes }}
                  </div>
                  <div v-if="product.additives && product.additives.length > 0" class="ingredients pl-4 text-grey-darkest">
                      Inhalt/Allergene: {{ product.additives }}
                  </div>
                </td>
                <td class="price w-4 lg:w-8 text-center" v-if="product.priceTiny">
                  <a class="zoomhover" tabindex="0" v-on:keydown.enter.prevent="addproduct" v-on:click="addproduct" :data-id="product.id" data-size="tiny" v-if="product.priceTiny != 0">{{ product.priceTiny | pricetag }}</a>
                </td>
                <td class="price w-4 lg:w-8 text-center" v-if="product.priceSmall">
                  <a class="zoomhover" tabindex="0" v-on:keydown.enter.prevent="addproduct" v-on:click="addproduct" :data-id="product.id" data-size="small" v-if="product.priceSmall != 0">{{ product.priceSmall | pricetag }}</a>
                </td>
                <td class="price w-4 lg:w-8 text-center" v-if="product.priceMedium">
                  <a class="zoomhover" tabindex="0" v-on:keydown.enter.prevent="addproduct" v-on:click="addproduct" :data-id="product.id" data-size="medium" v-if="product.priceMedium != 0">{{ product.priceMedium | pricetag }}</a>
                </td>
                <td class="price w-4 lg:w-8 text-center" v-if="product.priceLarge">
                  <a class="zoomhover" tabindex="0" v-on:keydown.enter.prevent="addproduct" v-on:click="addproduct" :data-id="product.id" data-size="big" v-if="product.priceLarge != 0">{{ product.priceLarge | pricetag }}</a>
                </td>
                <td class="price w-4 lg:w-8 text-center" v-if="product.priceFamily">
                  <a class="zoomhover" tabindex="0" v-on:keydown.enter.prevent="addproduct" v-on:click="addproduct" :data-id="product.id" data-size="family" v-if="product.priceFamily != 0">{{ product.priceFamily | pricetag }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <div v-if="host.item_menu_url" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm">
        <h3 class="border-b-0 mb-0">Original Speisekarte mit Hinweise zu Zutaten, Inhaltsstoffen und Allergenen</h3>
        <div>Wir versuchen immer bereits in der Auflistung bei allen Artikeln die Allergene und Zusatzstoffe aufzulisten. Aber gerne bieten wir dir hier zur Sicherheit die Original-Speisekarte des Anbieters zum Download.</div>
        <a :href="host.item_menu_url" target="_blank" class="block mt-2 text-black font-bold no-underline">📄 Download der Original Speisekarte</a>
      </div>

      <div v-if="allowAddProducts && away == false" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm">
        <p class="font-bold pb-4">Impressum des Anbieters</p>
        <div>{{ host.item_name }}</div>
        <div>{{ host.item_owner }}</div>
        <div>{{ host.item_street }} {{ host.item_houseno }}</div>
        <div>{{ host.item_plz }} {{ host.item_ort }}</div>
        <div v-if="host.item_taxnumber !== ''">Steuernummer: {{ host.item_taxnumber }}</div>
      </div>

      <menu-options @clicked="scrollToCategory" />
    </div>
    <div class="w-full bg-white lg:min-h-full lg:w-1/3 xl:max-w-md fixed pin-b pin-l lg:pin-none lg:pin-t lg:h-full lg:pin-r minibasket-container px-2 overflow-hidden lg:overflow-auto max-h-screen rounded-t-lg">
      <basketcomponent viewtype="menu"></basketcomponent>
    </div>

    <dialog class="z-50 productsize-dialog" name="productsize" height="auto" id="productsize-dialog">
      <div class="dialog__content">
        <h3 class="headline-extras">Wähle die gewünschte Größe</h3>
        <div class="bg-grey-lightest p-4 mb-8 text-sm">Klicke auf den Preis um den Artikel in der gewünschten Größe in den Warenkorb zu legen</div>
        <table class="products">
          <thead>
            <tr>
              <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="selectedProduct.priceTiny && selectedProduct.priceTiny != '0'">
                <template v-if="selectedProduct.titleTiny">{{ selectedProduct.titleTiny }}</template>
                <template v-else>Mini</template>
              </th>
              <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="selectedProduct.priceSmall && selectedProduct.priceSmall != '0'">
                <template v-if="selectedProduct.titleSmall">{{ selectedProduct.titleSmall }}</template>
                <template v-else>Klein</template>
              </th>
              <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="selectedProduct.priceMedium && selectedProduct.priceMedium != '0'">
                <template v-if="selectedProduct.titleMedium">{{ selectedProduct.titleMedium }}</template>
                <template v-else>Mittel</template>
              </th>
              <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="selectedProduct.priceLarge && selectedProduct.priceLarge != '0'">
                <template v-if="selectedProduct.titleLarge">{{ selectedProduct.titleLarge }}</template>
                <template v-else>Groß</template>
              </th>
              <th class="w-4 lg:w-8 bottomborder-green text-center" v-if="selectedProduct.priceFamily && selectedProduct.priceFamily != '0'">
                <template v-if="selectedProduct.titleFamily">{{ selectedProduct.titleFamily }}</template>
                <template v-else>Familie</template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="price w-4 lg:w-8 text-center" v-if="selectedProduct.priceTiny && selectedProduct.priceTiny != '0'">
                <a class="zoomhover" v-on:click="addproduct" :data-id="selectedProduct.id" data-size="tiny">{{ selectedProduct.priceTiny | pricetag }}</a>
              </td>
              <td class="price w-4 lg:w-8 text-center" v-if="selectedProduct.priceSmall && selectedProduct.priceSmall != '0'">
                <a class="zoomhover" v-on:click="addproduct" :data-id="selectedProduct.id" data-size="small">{{ selectedProduct.priceSmall | pricetag }}</a>
              </td>
              <td class="price w-4 lg:w-8 text-center" v-if="selectedProduct.priceMedium && selectedProduct.priceMedium != '0'">
                <a class="zoomhover" v-on:click="addproduct" :data-id="selectedProduct.id" data-size="medium">{{ selectedProduct.priceMedium | pricetag }}</a>
              </td>
              <td class="price w-4 lg:w-8 text-center" v-if="selectedProduct.priceLarge && selectedProduct.priceLarge != '0'">
                <a class="zoomhover" v-on:click="addproduct" :data-id="selectedProduct.id" data-size="big">{{ selectedProduct.priceLarge | pricetag }}</a>
              </td>
              <td class="price w-4 lg:w-8 text-center" v-if="selectedProduct.priceFamily && selectedProduct.priceFamily != '0'">
                <a class="zoomhover" v-on:click="addproduct" :data-id="selectedProduct.id" data-size="family">{{ selectedProduct.priceFamily | pricetag }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </dialog>

    <dialog class="z-50 paypalme-dialog" name="paypalme" height="auto" id="paypalme-dialog">
      <div class="dialog__content">
        <h3 class="headline-extras">Möchtest du Zahlungen deiner Mitbesteller erhalten?</h3>
        <p class="block text-grey-dark font-bold mb-1 md:mb-0 pr-4">
          Wenn du deinen PayPal.me Namen eingibst, erstellen wir deinen Mitbestellern einen persönlichen Zahlungslink mit den berechneten Summen ihrer Bestellungen:
        </p>
        <form class="w-full" v-on:submit.prevent="createOfficeSessionCall(true)">
          <div class="flex pt-4">
            <div class="md:w-1/3 table md:text-right">
              <div class="table-cell align-middle">paypal.me/</div>
            </div>
            <div class="md:w-2/3 pl-1">
              <input type="text" v-model="payPalMe" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
            </div>
          </div>
          <p class="block mb-1 md:mb-0 text-right">
            <a href="https://www.paypal.com/merchantapps/appcenter/acceptpayments/paypalme" target="_blank" class="text-grey-darker text-xs">Noch keinen PayPal.me Namen?</a>
          </p>
          <div class="md:flex md:items-center mt-6">
            <div class="md:w-1/2">
              <button @click="createOfficeSessionCall(false)" class="bg-transparent text-grey-dark font-bold py-2 px-0 rounded cursor-pointer" type="button">
                keine Zahlungen erhalten
              </button>
            </div>
            <div class="mt-2 md:mt-0 md:w-1/2 md:text-right">
              <button @click="createOfficeSessionCall(true)" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded cursor-pointer" type="button">
                mit PayPal starten
              </button>
            </div>
          </div>
        </form>
      </div>
    </dialog>
  </div>
</template>

<script>
import axios from 'axios'
import endpoints from '../../endpoints'
import Basketcomponent from '../../components/Basketcomponent.vue'
import ActiveHostComponent from '../../components/ActiveHostComponent.vue'
import Productrules from '../../components/Productrules.vue'
import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import MenuOptions from '../../components/MenuOptions.vue'
import { openDialog, closeDialog } from '../../utils/dialog'

export default {
  name: 'Speisekarte',

  data () {
    return {
      hostId: window.hostId,
      host: {
        item_name: ''
      },
      active: '',
      open: {},
      away: false,
      specials: [],
      categories: [],
      errors: [],
      selectedProduct: [],
      title: '',
      payPalMe: '',
      description: 'Essen online bestellen - keine Verständnis­probleme, keine Miss­verständ­nisse. Online­zahlung per PayPal, per Sofortüberweisung oder Barzahlung möglich.',
      showProductNumbers: (window.type === 'customer')
    }
  },

  created () {
    this.setUnloadEvents()

    if (Number(this.$route.params.hostUrl) > 0) {
      // redirection for old non-SEO urls
      axios.post(endpoints.gethosturlbyid, { id: this.$route.params.hostUrl })
        .then(response => {
          window.location.href = '/shop/' + response.data.item_url
        })
    } else {
      axios.post(endpoints.gethostbyurl, { url: this.$route.params.hostUrl })
        .then(response => {
          this.setHost(response.data.id)
          this.setOfficeOrderHostId({
            'hostId': response.data.id
          })
          this.hostId = response.data.id
          window.hostId = response.data.id

          axios.post(endpoints.sethost + response.data.id, {})
            .then(response => {
              this.renderMenu()
              this.checkActive()
            })
            .catch(e => {
              this.errors.push('Der Anbieter konnte nicht gesetzt werden 😭')
            })

          // store tableId if given
          if (typeof this.$route.params.tableId === 'string') {
            axios.post(endpoints.joinTable, {
              tableId: this.$route.params.tableId,
              tableToken: this.$route.params.tableToken,
              tableHost: response.data.id
            })
              .then(response => {
                this.setTable(response.data)
                this.setHomedelivery(false)
              })
          }
        })
        .catch(e => {
          this.errors.push('Der Anbieter konnte nicht geladen werden 😭')
        })
    }

    this.payPalMe = this.officeOrderPayPalMe

    window.eventBus.$on('renderMenu', data => {
      this.renderMenu()
    })
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  watch: {
    getSearchQuery: function () {
      this.renderMenu()

      const firstCategoryFound = (Object.values(this.categories).length > 0 ? Object.values(this.categories)[0][0].categoryId : false)
      if (firstCategoryFound) this.scrollToCategory(firstCategoryFound)
    }
  },

  components: {
    'basketcomponent': Basketcomponent,
    'activehostcomponent': ActiveHostComponent,
    'productrules': Productrules,
    'menu-options': MenuOptions
  },

  computed: {
    orderedCategories: function () {
      return _(this.categories).toPairs().sortBy(0).fromPairs().value()
    },

    allowAddProducts: function () {
      return this.active === 'Y' || this.host.item_auto_reactivate || (this.isLoggedIn && this.user.id === 1)
    },

    isOfficeMaster: function () {
      return this.hasOfficeOrder(this.host.id) && this.isOfficeOrderMaster
    },

    isOfficeClient: function () {
      return this.hasOfficeOrder(this.host.id) && this.isOfficeOrderClient
    },

    hasNavigatorShare: function () {
      return navigator.share
    },

    ...mapGetters([
      'getMenu',
      'getSearchQuery',
      'emptyBasket',
      'getScrollMenu',
      'hasOfficeOrder',
      'isOfficeOrderMaster',
      'isOfficeOrderClient',
      'isOfficeOrderClipboardSuccess',
      'isOfficeOrderShareSuccess',
      'officeOrder',
      'officeOrderLink',
      'officeOrderPayPalMe',
      'isLoggedIn',
      'user'
    ])
  },

  methods: {
    ...mapActions([
      'loadMenu',
      'updateBasket',
      'setHost',
      'setOfficeOrderHostId',
      'createOfficeOrder',
      'cancelOfficeOrderMaster',
      'cancelOfficeOrderClient',
      'inviteClients',
      'copyUrl'
    ]),

    ...mapMutations([
      'setTable',
      'setScrollMenu',
      'setOfficeOrderPayPalMe',
      'setHomedelivery'
    ]),

    closeDialog,

    renderMenu () {
      this.loadMenu({ hostId: this.hostId,
        callback: () => {
          const menu = this.getMenu
          this.title = 'Speisekarte von ' + menu.host.item_name + ' aus ' + menu.host.item_ort + ' | ' + this.site.domain
          this.description = 'Essen von ' + menu.host.item_name + ' aus ' + menu.host.item_ort + ' online bestellen - keine Verständnis­probleme, keine Miss­verständ­nisse. Online­zahlung per PayPal, per Sofortüberweisung oder Barzahlung möglich.'
          this.host = menu.host
          this.open = menu.open
          this.away = menu.away
          this.specials = menu.specials
          this.structreMenu(menu.products)

          if (menu.host.item_show_article_numbers === 'Y') {
            this.showProductNumbers = true
          }
        }})
    },

    checkActive () {
      axios.post(endpoints.hostactive, {
        'hostId': this.hostId
      })
        .then(response => {
          this.active = response.data.active
        })
        .catch(e => {
          this.errors.push('Wichtige Informationen zum Anbieter konnten nicht geladen werden 😭')
        })
    },

    scrollToCategory: function (categoryId) {
      if (categoryId) {
        const category = document.getElementById('cat-' + categoryId)
        if (category) {
          category.scrollIntoView({block: 'end'})
          category.scrollIntoView({block: 'start', behavior: 'smooth'})
        }
      } else {
        window.scrollTo({top: 0, behavior: 'smooth'})
      }
    },

    showproductsizes: function (event) {
      const productId = event.target.closest('td').dataset.id
      this.selectedProduct = _.find(this.getMenu.products, { 'id': productId })
      openDialog('productsize-dialog')
    },

    addproduct: function (event) {
      const productId = Number(event.target.dataset.id)
      const productSize = event.target.dataset.size

      if (this.active === 'N' && this.host.item_auto_reactivate) {
        if (!confirm('Der gewählte Anbieter ist aktuell ausgelastet und du kannst erst ab ' + this.host.item_auto_reactivate + ' Uhr wieder bestellen. Möchtest du den Artikel dennoch zum Warenkorb hinzufügen?')) {
          return false
        }
      }

      event.target.classList.add('loading')
      closeDialog('productsize-dialog')
      axios.post(endpoints.addproduct, {
        'hostId': this.hostId,
        'productId': productId,
        'size': productSize
      })
        .then(response => {
          const basketId = Number(response.data)

          window.eventBus.$emit('checkProductrules', {
            buildId: basketId,
            productId: productId,
            productSize: productSize
          })
          this.ga4_addToBasket(basketId)
          this.updateBasket()
          event.target.classList.remove('loading')
        })
        .catch(e => {
          this.errors.push('Der gewählte Artikel konnte nicht im Warenkorb abgelegt werden 😭')
          event.target.classList.remove('loading')
        })
    },

    ga4_addToBasket: function (basketId) {
      axios.post(endpoints.getBasketById, { basketId: basketId })
        .then(response => {
          window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'EUR',
              value: response.data.price,
              items: [
                {
                  item_id: response.data.item_product,
                  item_name: response.data.productdata.item_title,
                  affiliation: response.data.productdata.item_host,
                  index: 0,
                  item_category: response.data.item_category,
                  item_variant: response.data.item_size,
                  location_id: basketId,
                  price: response.data.price,
                  quantity: 1
                }
              ]
            }
          })
        })
    },

    structreMenu: function (products) {
      // apply filter if available
      if (this.getSearchQuery !== '') {
        products = products.filter((product) => {
          return (
            product.categoryName.toLowerCase().indexOf(this.getSearchQuery.toLowerCase()) !== -1 ||
            product.title.toLowerCase().indexOf(this.getSearchQuery.toLowerCase()) !== -1 ||
            product.content.toLowerCase().indexOf(this.getSearchQuery.toLowerCase()) !== -1
          )
        })
      }

      this.categories = _.groupBy(products, 'categoryId')

      _.each(this.categories, function (category, key) {
        _.each(['priceTiny', 'priceSmall', 'priceMedium', 'priceLarge', 'priceFamily'], function (size) {
          if (_.sumBy(category, function (o) { return Number(o[size]) }) === 0) {
            _.each(category, function (product, productKey) {
              _.unset(product, size)
            })
          }
        })
      })

      this.autoScroll()
    },

    createOfficeSession: function () {
      if (!this.isOfficeMaster) {
        openDialog('paypalme-dialog')
      }
    },

    createOfficeSessionCall: function (usePayPalMe) {
      this.setOfficeOrderPayPalMe(this.payPalMe)

      this.createOfficeOrder({
        'hostId': this.host.id,
        'paypalMe': usePayPalMe ? this.payPalMe : ''
      })

      closeDialog('paypalme-dialog')
    },

    abortOfficeOrderMaster () {
      this.cancelOfficeOrderMaster({
        'hostId': this.host.id
      })
    },

    abortOfficeOrderClient () {
      this.cancelOfficeOrderClient()
    },

    autoScroll () {
      this.$nextTick(() => {
        window.setTimeout(() => {
          window.scrollTo(0, this.getScrollMenu(this.hostId))
          window.addEventListener('scroll', this.handleScroll)
        }, 500)
      })
    },

    handleScroll () {
      this.setScrollMenu({
        hostId: this.hostId,
        scroll: window.scrollY
      })
    },

    setUnloadEvents () {
      window.onbeforeunload = (e) => {
        if (!this.isOfficeClient || this.emptyBasket) return
        e = e || window.event

        if (e) e.returnValue = 'Bist du sicher? Deine Bürobestellung wurde noch nicht abgeschlossen'
        return 'Bist du sicher? Deine Bürobestellung wurde noch nicht abgeschlossen'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    border-bottom: 3px solid #b1c800;
    padding-bottom: 10px;
  }

  .item_menu_content {
    @apply bg-grey-lightest;
    @apply border-l-4;
    border-color: #b1c800 !important;
    @apply p-4;
    @apply mb-8;
    @apply text-sm;
    max-height: 250px;
    overflow: auto;
  }

  div[data-modal="productsize"] {
    th {
      max-width: 250px;
    }

    td.price a[data-size] {
      margin-top: 10px;
      max-width: 250px;
      border: 1px solid #b1c800;
    }
  }

  @media (hover: hover) and (min-width: 500px) {
    .product {
      &:hover {
        .productImageContainer {
          @apply w-32;
        }
      }
    }
  }

  .productImage {
    @apply max-w-full;
    @apply h-auto;
    @apply rounded-full;
  }

  .productImageContainer {
    @apply float-left;
    @apply pr-2;
    @apply w-16;
    transition: width 0.25s;
  }

  .productNumberContainer {
    @apply float-left;
    @apply px-1;
    @apply mr-2;
    @apply text-xs;
    @apply bg-green-heinz;
    @apply font-bold;
    @apply text-white;
    @apply rounded;
    @apply text-center;
  }
</style>



// WEBPACK FOOTER //
// src/views/menu/index.vue